import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { discussionPlacement } from '../utils/sections';
const DAY = 24 * 3600 * 1000;
const PAGE = 50;
const MAX_PAGES = 4;
const SHOW = 5;
const MIN_FOR_DAY = 3;
const t = function (key, params) {
  if (params === void 0) {
    params = {};
  }
  return app.translator.trans(`tarotportal-theme.forum.home.${key}`, params);
};

/**
 * "Популярное за 24 часа": discussions ranked by the number of new replies (comments after the
 * first post) in the window, then by latest activity. Built from Flarum's posts API; nothing is
 * invented. Fewer than three active discussions in a day widens the window to a week; none at
 * all shows an empty state.
 */
export default class PopularDiscussions extends Component {
  loading = true;
  entries = [];
  window = 'day';
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  async load() {
    const posts = [];
    const weekAgo = Date.now() - 7 * DAY;
    try {
      for (let page = 0; page < MAX_PAGES; page++) {
        const batch = await app.store.find('posts', {
          filter: {
            type: 'comment'
          },
          sort: '-createdAt',
          page: {
            offset: page * PAGE,
            limit: PAGE
          },
          include: 'discussion,discussion.tags'
        });
        posts.push(...batch);
        const oldest = batch[batch.length - 1]?.createdAt()?.getTime() ?? 0;
        if (batch.length < PAGE || oldest < weekAgo) break;
      }
    } catch (e) {
      // Leave the block empty rather than failing the home page.
    }
    const rank = since => {
      const map = new Map();
      posts.forEach(post => {
        const at = post.createdAt()?.getTime() ?? 0;
        const discussion = post.discussion();
        if (!discussion || at < since || post.number() === 1) return;
        const entry = map.get(discussion.id()) || {
          discussion,
          replies: 0,
          lastAt: 0
        };
        entry.replies++;
        entry.lastAt = Math.max(entry.lastAt, at);
        map.set(discussion.id(), entry);
      });
      return [...map.values()].sort((a, b) => b.replies - a.replies || b.lastAt - a.lastAt).slice(0, SHOW);
    };
    this.entries = rank(Date.now() - DAY);
    if (this.entries.length < MIN_FOR_DAY) {
      const week = rank(weekAgo);
      if (week.length > this.entries.length) {
        this.entries = week;
        this.window = 'week';
      }
    }
    this.loading = false;
    m.redraw();
  }
  view() {
    return m("div", {
      className: "TpPopular"
    }, m("p", {
      className: "TpEyebrow TpEyebrow--muted TpRule"
    }, t(this.window === 'day' ? 'popular_day' : 'popular_week')), this.loading ? m(LoadingIndicator, {
      display: "block"
    }) : this.entries.length ? m("ol", {
      className: "TpNumbered"
    }, this.entries.map((_ref, i) => {
      let {
        discussion,
        replies
      } = _ref;
      const {
        subsection,
        section
      } = discussionPlacement(discussion.tags() || []);
      return m("li", null, m("span", {
        className: "TpNum"
      }, String(i + 1).padStart(2, '0')), m("div", null, m(Link, {
        className: "TpNumbered-title",
        href: app.route.discussion(discussion)
      }, discussion.title()), m("span", {
        className: "TpMeta"
      }, (subsection || section)?.name(), " \xB7 ", t(this.window === 'day' ? 'replies_day' : 'replies_week', {
        count: replies
      }))));
    })) : m("p", {
      className: "TpPopular-empty"
    }, t('popular_empty')));
  }
}
flarum.reg.add('tarotportal-theme', 'forum/components/PopularDiscussions', PopularDiscussions);